import { render, staticRenderFns } from "./PelletsTable.vue?vue&type=template&id=76d167ca&scoped=true"
import script from "./PelletsTable.vue?vue&type=script&lang=ts"
export * from "./PelletsTable.vue?vue&type=script&lang=ts"
import style0 from "./PelletsTable.vue?vue&type=style&index=0&id=76d167ca&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d167ca",
  null
  
)

export default component.exports